import { AfterContentInit, AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-aoi',
  templateUrl: './aoi.component.html',
  styleUrls: ['./aoi.component.css']
})
export class AOIComponent implements AfterContentInit, AfterViewInit {

  @ViewChild('stateTab', { static: false }) private readonly stateTab: ElementRef<any>;
  @ViewChild('regionTab', { static: false }) private readonly regionTab: ElementRef<any>;
  @ViewChild('routeTab', { static: false }) private readonly routeTab: ElementRef<any>;
  @ViewChild('addressTab', { static: false }) private readonly addressTab: ElementRef<any>;
  @ViewChild('latLongTab', { static: false }) private readonly latLongTab: ElementRef<any>;
  @ViewChild('intersectionTab', { static: false }) private readonly intersectionTab: ElementRef<any>;
  @ViewChild('interstateTab', { static: false }) private readonly interstateTab: ElementRef<any>;
  @ViewChild('assetIdTab', { static: false }) private readonly assetIdTab: ElementRef<any>;

  @Output() AOIGo: EventEmitter<string[]> = new EventEmitter();
  @Output() closeAOIWindow: EventEmitter<void> = new EventEmitter();
  @Output() filterInterstate: EventEmitter<string> = new EventEmitter();
  @Output() clearFilter: EventEmitter<void> = new EventEmitter();

  private activateAOITabSubscription: Subscription;
  @Input() activateAOITab: Observable<void>;

  private deeplinkPresentSubscription: Subscription;
  @Input() deeplinkPresent: Observable<void>;

  isLoading = false;

  aoiTabs = [
    { name: 'State' },
    { name: 'Region', active: true },
    { name: 'Route' },
    { name: 'Address' },
    { name: 'Lat/Long' },
    { name: 'Intersection' },
    { name: 'Interstate' },
    { name: 'Asset Id' }
  ];

  aoiTabsMobile = [
    { name: 'Region', active: true },
    { name: 'Route' },
    { name: 'Address' },
    { name: 'Interstate' },
    { name: 'Asset Id'}
  ];

  assetIdConfig = [
    {
      columnName: 'HPMS_SAMP_SECT_NO',
      displayName: 'HPMS Sample IDs',
      idType: '$stringIds',
      propName: 'samples',
      fieldName: 'sampleId',
      layerId: 2000
    },
    {
      columnName: 'BRKEY',
      displayName: 'Bridge Keys',
      idType: '$stringIds',
      propName: 'bridges',
      fieldName: 'brKey',
      layerId: 1592
    },
    {
      columnName: 'PERMIT_NUM',
      displayName: 'Permit Numbers',
      idType: '$stringIds',
      propName: 'permitNums',
      fieldName: 'permitNum',
      layerId: 9144
    },
    {
      columnName: 'APPLICATION_ID',
      displayName: 'Permit Applications',
      idType: '$stringIds',
      propName: 'permitApps',
      fieldName: 'permitApp',
      layerId: 9144
    },
    {
      columnName: 'PROJECT_ID',
      displayName: 'MPMS Projects',
      idType: '$stringIds',
      propName: 'mpmsprojects',
      fieldName: 'id',
      layerId: 2751
    },
    {
      columnName: 'TMS_SITE_NO',
      displayName: 'TMS Site Numbers',
      idType: '$stringIds',
      propName: 'tmsSite',
      fieldName: 'tmsSiteNo',
      layerId: 2611
    },
    {
      columnName: 'SIGN_APPL_ID',
      displayName: 'Billboard IDs',
      idType: '$stringIds',
      propName: 'billboards',
      fieldName: 'bilboardId',
      layerId: 6763
    }
  ];

  assetIdProperties = 'samples,bridges,permitNums,permitApps,mpmsprojects,tmsSite,billboards';

  activeTab: any;
  aoiService: any;
  layerService: any;
  mapService: any;
  filterSet = false;
  isMobileView = false;
  constructor() {

  }

  ngAfterContentInit() {
    if (window.location.href.includes('?showMobile=true')) {
      this.isMobileView = true;
    }
  }

  ngAfterViewInit() {
    this.aoiService = this.regionTab.nativeElement.AoiService;
    this.activeTab = this.regionTab;
    this.aoiService.boundarySymbol = {
      color: [255, 255, 0, 0.3],
      style: 'solid',
      outline: {
        color: [0, 0, 0],
        style: 'solid',
        width: 2
      }
    };
    this.aoiService.lineSymbol = {
      'type': 'simple',
      'symbol': {
        'type': 'esriSLS',
        'color': [
          255,
          255,
          0
        ],
        'width': 4,
        'style': 'esriSLSSolid'
      }
    };

    // configure assetId aoi
    this.assetIdTab.nativeElement.config = this.assetIdConfig;
    this.assetIdTab.nativeElement.properties = this.assetIdProperties;

    this.activateAOITabSubscription = this.activateAOITab.subscribe(() => this.activateTab());
    this.deeplinkPresentSubscription = this.deeplinkPresent.subscribe(() => {
      const aoiType: string[] = this.getAoiType();
      this.emitAOIComplete(aoiType);
    });
  }

  activateTab() {
    this.activeTab.nativeElement.activate();
  }

  onTabChange(event) {
    switch (event.detail.name) {
      case 'State':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.stateTab;
        this.activateTab();
        break;

      case 'Region':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.regionTab;
        this.activateTab();
        break;

      case 'Route':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.routeTab;
        this.activateTab();
        break;

      case 'Address':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.addressTab;
        this.activateTab();
        break;

      case 'Lat/Long':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.latLongTab;
        this.activateTab();
        this.latLongTab.nativeElement.activate(); // loads latLong map
        break;

      case 'Intersection':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.intersectionTab;
        this.activateTab();
        break;

      case 'Interstate':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.interstateTab;
        this.activateTab();
        break;

      case 'Asset Id':
        this.aoiService.clearSearchCriterias();
        this.activeTab = this.assetIdTab;
        this.activateTab();
        break;

      default:
        break;
    }
  }

  public async go() {
    try {
      this.isLoading = true;
      this.activeTab.nativeElement.addResultToMap();
      await this.aoiService.showBySearchCriterias();

    } catch (error) {
      console.error(error);

    } finally {
      if (this.filterSet) {
        this.clearFilter.emit();
      }

      /* add filter if on interstate AOI tab */
      if (this.activeTab === this.interstateTab) {
        // send event to maps
        const routeNumber: string = this.getInterstateRouteNumber();
        this.filterInterstate.emit(routeNumber);
        this.filterSet = true;
        setTimeout(() => {
          this.isLoading = false;
          this.emitAOIComplete(this.getAoiType());
        }, 750);

      } else {
        this.isLoading = false;
        this.emitAOIComplete(this.getAoiType());
      }
    }
  }

  emitAOIComplete(aoiType: string[]) {
    this.AOIGo.emit(aoiType);
  }

  closeAoiTool() {
    this.closeAOIWindow.emit();
  }

  getAoiType(): string[] {
    const criterias: any[] = this.aoiService.getSearchCriterias();
    return [criterias[0].type, criterias[0].name];
  }

  getInterstateRouteNumber(): string {
    const criterias: any[] = this.aoiService.getSearchCriterias();
    if (criterias[0] && criterias[0].stateRouteNumber) {
      return criterias[0].stateRouteNumber.toString();
    }
  }
}
